import { Component } from "@angular/core";
import { Router } from "@angular/router";
import { MatDialogModule, MatDialogRef } from "@angular/material/dialog";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";

import { TawkService } from "../../services/tawk.service";

@Component({
  selector: "app-quiz-match-dialog",
  standalone: true,
  imports: [MatDialogModule, MatButtonModule, MatIconModule],
  templateUrl: "./quiz-match-dialog.component.html",
  styleUrl: "./quiz-match-dialog.component.scss"
})
export class QuizMatchDialogComponent {
  constructor(
    readonly ref: MatDialogRef<QuizMatchDialogComponent, void>,
    private readonly tawk: TawkService,
    private readonly router: Router
  ) {}

  /** Loads Tawk (if needed) and opens the chat panel so the visitor can message Gage. */
  async openChatWithGage(): Promise<void> {
    this.ref.close();
    void this.router.navigate(["/chat"], { queryParams: { openChat: "1" } });
  }

  /** Navigates to Chat; the page opens Tawk when `openChat=1` is present. */
  goToChatPage(): void {
    this.ref.close();
    void this.router.navigate(["/chat"], { queryParams: { openChat: "1" } });
  }

  dismiss(): void {
    this.ref.close();
  }
}
